import React, { Component } from 'react';
import { BrowserRouter, Route, Switch  } from 'react-router-dom';

import HomeComponent from '../components/home';
import LoginComponent from '../components/authentications/login/loginComponent';
import LeftSidebar from '../components/commons/layouts/leftSidebarComponent';
import Settings from '../components/commons/layouts/settingsComponent';
import Content from './contentComponent';
import ResetPasswordComponent from '../components/commons/resetPasswordComponent';
import EmailVerificationComponent from '../components/commons/emailVerificationComponent'
import ForgotPasswordComponent from '../components/commons/forgotPassword'
import TermsAcceptComponent from '../components/authentications/login/termsAcceptComponent';

import * as staticConfigs from '../configs/staticConfigs';

class Router extends Component {
    
    render() {
       
        return (
          <BrowserRouter>

            <LeftSidebar />
            <Content />           

            <Switch>              
                <Route path='/' exact={true} component={HomeComponent} />
                <Route exact path={staticConfigs.LOGIN_ROUTE_SUPER_ADMIN} component={LoginComponent} />
                <Route exact path={staticConfigs.LOGIN_ROUTE_AFFILIATE} component={LoginComponent} />
                <Route exact path={staticConfigs.LOGIN_ROUTE_CLIENT} component={LoginComponent} />
                <Route exact path={staticConfigs.ROUTE_RESET_PASSWORD} component={ResetPasswordComponent} />
                <Route exact path={staticConfigs.ROUTE_VERIFY_EMAIL} component={EmailVerificationComponent} />
                <Route exact path={staticConfigs.ROUTE_FORGOT_PASSWORD} component={ForgotPasswordComponent} />
                <Route exact path={staticConfigs.ROUTE_TERMS_ACCEPT} component={TermsAcceptComponent} />
                <Route exact path={staticConfigs.ROUTE_AFFILIATE_TERMS_ACCEPT} component={TermsAcceptComponent} />
                <Route exact path={staticConfigs.ROUTE_CLIENT_TERMS_ACCEPT} component={TermsAcceptComponent} />
            </Switch>

            <Settings />

          </BrowserRouter>
        )
    }

}

export default Router;